export const environment = {
  production: true,
  environment_name: 'clearwater',
  environment_title: 'Clearwater Mall',
  environment_url: 'https://clearwatermall.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: 'f4b417b2-ec35-4e69-9145-1a50adc97103',
  addressLat: -26.127298505162198,
  addressLng: 27.90469188388705,
  cinemaID: 25,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'IzVddOAJJmOsVek-j9B46cLWiRTzf3yCCRmuQDG3Uvo',
  street_address: 'Hendrik Potgieter Rd',
  address_locality: 'Roodepoort',
  postal_code: '1735',
  address_country: 'ZA',
  contact_form_uuid: 'im35z1wq',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/b2213e98-9cbe-4799-9eb2-b336daeca01f/11e16c5e-b384-447e-b767-91e6055fccf1.pdf',
  tiktok_url: 'https://www.tiktok.com/@clearwater.mall',
};
